import React from "react";

// Main tab bar. Kept presentational: App.js owns the dirty-form guard inside
// onTabChange, so this only reports the requested tab upward.
const TABS = [
  { key: "scan", label: "📷 Scan" },
  { key: "dashboard", label: "Dashboard" },
  { key: "inventory", label: "Inventory" },
  { key: "items", label: "Item Management" },
  { key: "reorder", label: "Reorder" },
  { key: "config", label: "Configuration" },
  { key: "equipment", label: "🔧 Equipment" },
];

const AppTabNav = ({ activeTab, onTabChange, isGlobalAdmin }) => (
  <nav className="tabs" aria-label="Main sections" role="tablist">
    {TABS.map((tab) => (
      <button
        key={tab.key}
        className={`tab-button ${activeTab === tab.key ? "active" : ""}`}
        onClick={() => onTabChange(tab.key)}
        role="tab"
        aria-selected={activeTab === tab.key}
        aria-controls="main-content"
      >
        {tab.label}
      </button>
    ))}
    {isGlobalAdmin && (
      <button
        className={`tab-button ${activeTab === "hospitals" ? "active" : ""}`}
        onClick={() => onTabChange("hospitals")}
        role="tab"
        aria-selected={activeTab === "hospitals"}
        aria-controls="main-content"
      >
        🏥 Hospitals
      </button>
    )}
  </nav>
);

export default AppTabNav;
